















































































import Vue from 'vue';
import {mapActions, mapGetters} from "vuex";

export default Vue.extend({
  name: 'ProjectList',
  data() {
    return {
      filter: "",
      sorter: { label: 'Last Updated', expr: (a: any, b: any) => b.updated_at - a.updated_at },
      sorterItems: [
        { label: 'Last Updated', expr: (a: any,b: any) => b.updated_at - a.updated_at },
        { label: 'Last Created', expr: (a: any, b: any) => b.created_at - a.created_at },
        { label: 'Last Deadline', expr: (a: any, b: any) => b.deadline - a.deadline },
      ],
    }
  },
  computed: {
    ...mapGetters('projects', [
      'isLoading',
      'isAvailable',
      'lastUpdated',
    ]),
    ...mapGetters('projects', {
      availableProjects: 'getAvailableCollection',
    }),
    projects(): any[] {
      return Object.assign([], this.availableProjects)
          .filter((project: any) => {
            return project.name.toLowerCase().includes(this.filter.toLowerCase())
          })
          .sort(this.sorter.expr);
    },
  },
  mounted() {
    this.refresh();
  },
  methods: {
    ...mapActions('projects', [
      'list',
    ]),
    debug() {
      console.log(this.sorter);
    },
    refresh() {
      this.list()
          .catch((e: Error) => {
            if (!this.isAvailable) {
              console.log(e);
              this.$notify({
                type: 'error',
                title: "An error occurred",
                text: "Try again later",
              });
            }
          });
    }
  },
});
